import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useEmpresa } from "@/hooks/empresas";
import { AvaliacaoProvider } from "@/context/avaliacoes/avaliacao";
// import { AssinanteProvider } from "@/context/assinantes/assinante";
import { EmpresaProvider } from "@/context/empresas/empresa";
import { FranqueadosProvider } from "@/context/franqueados";
import { Page, DashboardContainer } from "@/components/Grid";
import { Navbar } from "@/components/Blocks";
import { FullPageLoader } from "@/components/Common";
import { Sidebar, SubMenu, Sobre, ListarCursos, ListarAssinantes } from "@/components/Escola";
import ListarAvaliacoes from "@/components/Empresa/Avaliacoes/ListarAvaliacoes";
import { TCEs } from "@/components/Empresa";

import {
  PaineisContainer,
  Content,
  MenuInterno,
  PainelPrincipal,
} from "./styles";

function _Perfil() {
  const { data: user } = useSelector(state => state.auth);
  const { fetchEmpresa, empresa } = useEmpresa();

  useEffect(() => {
    fetchEmpresa(user.empresa.id);
  }, []);

  return (
    <Page>
      <Navbar type="interna" />
      {!empresa && <FullPageLoader />}
      {empresa && (
        <DashboardContainer>
          <PaineisContainer>
            <Sidebar />
            <Content>
              <MenuInterno>
                <SubMenu type="empresa" />
              </MenuInterno>
              <PainelPrincipal>
                <h1>Escola</h1>
                <Tabs forceRenderTabPanel={true}>
                  <TabList>
                    <Tab>Sobre a escola</Tab>
                    {user.tipo === "funcionario" && <Tab>Cursos</Tab>}
                    <Tab>Contratos</Tab>
                    <Tab>Avaliações</Tab>
                    <Tab>Assinantes</Tab>
                    {/* <Tab>Conta</Tab> */}
                  </TabList>
                  <TabPanel>
                    <Sobre />
                  </TabPanel>
                  {user.tipo === "funcionario" && (
                    <TabPanel>
                      <ListarCursos empresaId={empresa.id} />
                    </TabPanel>
                  )}
                  <TabPanel>
                    <TCEs />
                  </TabPanel>
                  <TabPanel>
                    <ListarAvaliacoes />
                  </TabPanel>
                  <TabPanel>
                    <ListarAssinantes />
                  </TabPanel>
                  {/* <TabPanel></TabPanel> */}
                </Tabs>
              </PainelPrincipal>
            </Content>
          </PaineisContainer>
        </DashboardContainer>
      )}
    </Page>
  );
}

export default function Perfil(props) {
  return (
    <EmpresaProvider>
      <FranqueadosProvider>
        <AvaliacaoProvider>
          <_Perfil {...props} />
        </AvaliacaoProvider>
      </FranqueadosProvider>
    </EmpresaProvider>
  );
}
